export interface ETLMetricRecalculationObj {
    MetricID: number;
    MetricName: string;
    Group: string;
    Components: Components[];
    Type: MetricTypes;
    LastModified: string | Date;
}

export interface ETLMetricRecalculationGridObj {
    MetricID: string;
    MetricName: string;
    Group: string;
    Components: string;
}

export interface Components {
    ReportingSetName: string;
    ReportingSetGroup: string;
}

export interface ETLReportingSetRecalculationObj {
    BaseFeed: string;
    _id: string;
    ReportingSetName: string;
    ReportingSetGroup: string;
}

export interface SaveRecalculationDataObj {
    startDate: string;
    endDate: string;
    metricIds: string[];
    reportingSetIds: string[],
    hierarchyIds: string[]
}

export enum MetricTypes {
    Standard,
    RealTime,
    Calculated,
    RealTimeApi
}
